import React from "react";
import { ISAD_CONFIG } from "../../models/isad";

const ACTION_CONFIG = {
  physical: {
    icon: "🛠️",
    label: "Physical maintenance needed",
    description:
      "Infrastructure condition is the limiting factor. Schedule physical inspection and maintenance works.",
    wrapCls:
      "border-orange-200 bg-orange-50 dark:border-orange-700 dark:bg-orange-900/20",
    textCls: "text-orange-800 dark:text-orange-300",
  },
  ctag: {
    icon: "📡",
    label: "Connectivity upgrade needed",
    description:
      "Connectivity is the limiting factor. Evaluate OBU coverage and roadside unit deployment.",
    wrapCls:
      "border-blue-200 bg-blue-50 dark:border-blue-700 dark:bg-blue-900/20",
    textCls: "text-blue-800 dark:text-blue-300",
  },
  none: {
    icon: "🔍",
    label: "Further investigation — conflicting signals",
    description:
      "Both systems are at equal levels. Gather additional data before deciding on an intervention type.",
    wrapCls:
      "border-gray-200 bg-gray-50 dark:border-white/10 dark:bg-navy-900/40",
    textCls: "text-gray-700 dark:text-gray-300",
  },
};

const WhatCanBeDone = ({ detail, onSegmentFocus }) => {
  const action =
    ACTION_CONFIG[detail.binding_constraint ?? "none"] ?? ACTION_CONFIG.none;

  return (
    <section className="p-4">
      <p className="mb-3 text-[10px] font-bold uppercase tracking-widest text-gray-400">
        What can be done
      </p>
      <div className={`mb-4 rounded-lg border p-3 ${action.wrapCls}`}>
        <p
          className={`mb-1 flex items-center gap-1.5 text-xs font-bold ${action.textCls}`}
        >
          <span aria-hidden="true">{action.icon}</span>
          <span>{action.label}</span>
        </p>
        <p className={`text-xs leading-relaxed opacity-85 ${action.textCls}`}>
          {action.description}
        </p>
      </div>
      {detail.similar_segments.length > 0 && (
        <div className="mb-4">
          <p className="mb-2 text-xs font-semibold text-gray-500 dark:text-gray-400">
            Similar segments that improved
          </p>
          <ul className="space-y-1.5">
            {detail.similar_segments.slice(0, 3).map((seg) => {
              const outcomeCfg = ISAD_CONFIG[seg.outcome_level];
              return (
                <li key={seg.segment_id}>
                  <button
                    onClick={() => onSegmentFocus(seg.segment_id)}
                    className="flex w-full items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-left transition-colors hover:border-brand-400 hover:bg-brand-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-white/10 dark:bg-navy-900/40 dark:hover:border-brand-500"
                  >
                    <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                      {seg.label}
                    </span>
                    <span
                      className="text-xs font-semibold"
                      style={{ color: outcomeCfg?.color ?? "#9e9e9e" }}
                    >
                      → {seg.outcome_level}{" "}
                      {outcomeCfg?.label ? `(${outcomeCfg.label})` : ""}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      <button
        disabled
        title="Scenarios module is not yet available"
        aria-disabled="true"
        className="w-full cursor-not-allowed rounded-lg border border-gray-200 bg-gray-100 px-3 py-2.5 text-xs font-semibold text-gray-400 dark:border-white/5 dark:bg-white/5 dark:text-gray-500"
      >
        Test intervention in Scenarios
      </button>
    </section>
  );
};

export default WhatCanBeDone;
